/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-07 15:55:38
 * @LastEditTime: 2019-08-27 14:45:00
 * @LastEditors: Please set LastEditors
 */
import { call, put, select } from 'redux-saga/effects'
// import _ from 'lodash'
import {
  getLessonsList,
  lessonCreate,
  getLessonById,
  lessonUpdate
} from '../../services/api/lessons'

import * as lessons from '../actions/lessonBuilder'

const hasMissingPageIds = pages =>
  Array.isArray(pages) && pages.some(page => page && !page.id)

const buildMissingPage = (page, orientation) => {
  if (!page) {
    return {
      data: [],
      orientation,
      size:
        orientation === 'portrait'
          ? { width: 768, height: 1024 }
          : { width: 1024, height: 768 }
    }
  }

  const { id, ...pageWithoutId } = page

  return {
    ...pageWithoutId,
    data: Array.isArray(page.data) ? page.data : [],
    orientation
  }
}

const normalizeLessonPageArrays = data => {
  if (
    !data ||
    !Array.isArray(data.pages) ||
    !Array.isArray(data.pages_landscape)
  ) {
    return { data, changed: false }
  }

  const { pages, pages_landscape: pagesLandscape } = data
  const maxLength = Math.max(pages.length, pagesLandscape.length)
  let changed = pages.length !== pagesLandscape.length

  const normalizedPages = []
  const normalizedPagesLandscape = []

  for (let index = 0; index < maxLength; index += 1) {
    if (pages[index]) {
      normalizedPages.push(pages[index])
    } else {
      normalizedPages.push(buildMissingPage(pagesLandscape[index], 'portrait'))
      changed = true
    }

    if (pagesLandscape[index]) {
      normalizedPagesLandscape.push(pagesLandscape[index])
    } else {
      normalizedPagesLandscape.push(buildMissingPage(pages[index], 'landscape'))
      changed = true
    }
  }

  if (!changed) {
    return { data, changed }
  }

  return {
    data: {
      ...data,
      pages: normalizedPages,
      pages_landscape: normalizedPagesLandscape
    },
    changed
  }
}

const hydratePageMetadata = (localPages = [], savedPages = []) => {
  if (
    !Array.isArray(localPages) ||
    !Array.isArray(savedPages) ||
    localPages.length !== savedPages.length
  ) {
    return localPages
  }

  return localPages.map((page, index) => {
    const savedPage = savedPages[index]

    if (!page || !savedPage) return page

    return {
      ...page,
      id: page.id || savedPage.id,
      uid: page.uid || savedPage.uid,
      ordering: page.ordering || savedPage.ordering
    }
  })
}

export function * createLesson (action) {
  yield put(lessons.setSavingLesson(true))
  try {
    const { data } = normalizeLessonPageArrays(action.data)
    const response = yield call(lessonCreate, data, action.id)

    if (response.status === 200) {
      const lessonId = response.data.id

      yield call(lessonUpdate, data, lessonId)
      yield put(lessons.handleLessonInput('lessonId', lessonId))
    }
    yield put(lessons.setSavingLesson(false))
  } catch (err) {
    console.log(JSON.stringify(err))
  }
}

export function * updateLesson (action) {
  try {
    yield put(lessons.setSavingLesson(true))
    const { data, changed } = normalizeLessonPageArrays(action.data)
    const response = yield call(lessonUpdate, data, action.id)
    const state = yield select()
    const { pages, pages_landscape: pagesLandscape } = state.lessonBuilder
    const pagesForHydration = changed ? data.pages : pages
    const pagesLandscapeForHydration = changed
      ? data.pages_landscape
      : pagesLandscape

    if (changed) {
      yield put(lessons.handleLessonInput('pages', data.pages))
      yield put(
        lessons.handleLessonInput('pages_landscape', data.pages_landscape)
      )
    }

    if (
      hasMissingPageIds(pagesForHydration) ||
      hasMissingPageIds(pagesLandscapeForHydration)
    ) {
      const hydratedPages = hydratePageMetadata(
        pagesForHydration,
        response.data.pages
      )
      const hydratedLandscapePages = hydratePageMetadata(
        pagesLandscapeForHydration,
        response.data.pages_landscape
      )

      yield put(lessons.handleLessonInput('pages', hydratedPages))
      yield put(
        lessons.handleLessonInput('pages_landscape', hydratedLandscapePages)
      )
    }

    yield put(lessons.setSavingLesson(false))
  } catch (err) {
    yield put(lessons.setSavingLesson(false))
  }
}

export function * fetchLessons (action) {
  yield put(lessons.fetchLessonsRequest(true))

  try {
    const response = yield call(getLessonsList, action.payload)
    const data = response.data
    yield put(lessons.loadLessons(data))
    yield put(lessons.fetchLessonsRequest(false))
  } catch (err) {
    yield put(lessons.fetchLessonsRequest(false))
  }
}

export function * fetchLessonById (action) {
  yield put(lessons.fetchLessonRequest())

  try {
    const response = yield call(getLessonById, action.id)
    if (response.status === 200) {
      yield put(lessons.loadSingleLesson(response.data))
    }
  } catch (err) {
    console.log(JSON.stringify(err))
  }
}
